import api from "./api";
import { Plan } from "../types";

async function get_plan(user_id: string | number): Promise<Plan[]> {
  try {
    const { data } = await api.get(`/plans/${user_id}/`);
    // Ensure we return an array, handling potential single object response legacy
    if (Array.isArray(data)) {
      return data;
    }
    return data ? [data] : [];
  } catch (e) {
    return [];
  }
}

const plans = { get_plan };

export default plans;
